import React from 'react';
import { Badge } from 'reactstrap';
import { OrderFulfillmentStatus } from '../../graphql/generatedTypes';
import i18n from '@/utils/i18n';

const getOrderfulfillmentStatusColor = (
  status: OrderFulfillmentStatus,
): string => {
  switch (status) {
    case OrderFulfillmentStatus.AllCounted:
      return 'success';
    case OrderFulfillmentStatus.MissingCounts:
      return 'warning';

    default:
      break;
  }

  return 'error';
};

type OrderfulfillmentStatusBadgeProps = {
  status: OrderFulfillmentStatus | null | undefined;
};

const OrderfulfillmentStatusBadge = ({
  status,
}: OrderfulfillmentStatusBadgeProps) => {
  if (!status) {
    return <>-</>;
  }

  return (
    <Badge
      color={getOrderfulfillmentStatusColor(status)}
      className="border border-1"
      pill
    >
      {i18n.t(`OrderFulfillment:status_${status}`)}
    </Badge>
  );
};

export default OrderfulfillmentStatusBadge;
